import { Link } from "react-router-dom";
import Divider from "../../components/Divider";
import TabContentContainer from "../../components/TabContentContainer";
import Text from "../../components/Text";

const OnlineServiceTab = () => {
  return (
    <>
      <div className="heading text-[#5f5f5f] pb-5">
        <Text classes="uppercase font-bold font-medium" component={"h6"}>
          Pricing Categories
        </Text>
      </div>
      <Divider />
      <div className="categories">
        <ul className="categories-wrapper text-[13px]">
          <li className="single-category border-b last:border-b-0">
            <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
              <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                <Text
                  classes="font-medium text-black text-base"
                  component={"h4"}
                >
                  Initial Assessment
                </Text>
                <Text>
                  15 minutes initial consultation, Initial dietary analysis
                </Text>
              </div>
              <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row justify-end xs:my-3 md:my-0 text-right">
                <Text classes={"text-[#e66553] text-sm"}>15 min</Text>
              </div>
              <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                <div className="price mr-6">
                  <Text
                    classes={"text-[#e66553] text-sm font-medium"}
                    component={"strong"}
                  >
                    Free
                  </Text>
                </div>
                <div className="action">
                  <Link
                    to="scheduling"
                    className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                  >
                    Start Now
                  </Link>
                </div>
              </div>
            </div>
          </li>
          <li className="single-category border-b last:border-b-0">
            <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
              <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                <Text
                  classes="font-medium text-black text-base"
                  component={"h4"}
                >
                  Initial Assessment
                </Text>
                <Text>Weekly follow-ups</Text>
                <Text>App Support</Text>
                <Text>Progress Tracker</Text>
                <Text>Customized Snack Box</Text>
              </div>
              <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0 text-right">
                <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                <Text classes={"text-[#e66553] text-sm mr-1"}>min/weekly</Text>
              </div>
              <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                <div className="price mr-6 flex flex-col items-end">
                  <Text classes={"text-[#e66553] text-sm font-medium"}>
                    $99
                  </Text>
                  <Text classes={"text-[#747474] text-[11px] font-medium"}>
                    Monthly
                  </Text>
                </div>
                <div className="action">
                  <Link
                    to="scheduling"
                    className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                  >
                    Start Now
                  </Link>
                </div>
              </div>
            </div>
          </li>
          <li className="single-category border-b last:border-b-0">
            <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
              <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                <Text
                  classes="font-medium text-black text-base"
                  component={"h4"}
                >
                  Transform Me
                </Text>
                <Text>Weekly follow-ups</Text>
                <Text>App Support</Text>
                <Text>Progress Tracker</Text>
                <Text>Customized Snack Box</Text>
              </div>
              <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                <Text classes={"text-[#e66553] text-sm mr-1"}>min/weekly</Text>
              </div>
              <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                <div className="price mr-6 flex flex-col items-end">
                  <Text classes={"text-[#e66553] text-sm font-medium"}>
                    $99
                  </Text>
                  <Text classes={"text-[#747474] text-[11px] font-medium"}>
                    Monthly
                  </Text>
                </div>
                <div className="action">
                  <Link
                    to="scheduling"
                    className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                  >
                    Start Now
                  </Link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default OnlineServiceTab;
